import { ReducerBuilder } from 'typescript-fsa-reducers';

import { applyAsyncReducer } from '@utils';

import { zeppUpdateSettings } from './zeppUpdateSettings';

import { IAuthStore } from '../../types';
import { IActionZeppUpdateSettingsPayloadDone } from './types';

export const zeppUpdateSettingsReducer = (auth: ReducerBuilder<IAuthStore, IAuthStore>) => {
	applyAsyncReducer<IAuthStore['user']['data'], IAuthStore['user']['meta']>()(
		'user',
		'networkStatus',
		zeppUpdateSettings.async,
		auth,
		(props: { result: IActionZeppUpdateSettingsPayloadDone }) => ({
			user: props.result.user,
		}),
	);
};
